import { useContext } from "react";
import { FustContext } from "../context/FustContext";

export const useFustContext = () => {
  const context = useContext(FustContext);

  if (!context) {
    throw new Error("useFustContext moet binnen een FustProvider worden gebruikt");
  }

  return context;
};
